import React, { useEffect } from 'react';
import { useNavigate, useLocation, Navigate } from 'react-router-dom';
import '../styles/BaseForm.css';
import fr from '../locales/fr';
import en from '../locales/en';

function Reconnect({ ws }) {
  const navigate = useNavigate();
  const location = useLocation();
  const browserLang = navigator.language || navigator.userLanguage;
  const language = browserLang.startsWith('fr') ? 'fr' : 'en';
  const translations = language === 'fr' ? fr : en;

  const allowed =
    location.state?.fromAuthorized ||
    sessionStorage.getItem('canAccessReconnect');

  useEffect(() => {
    if (allowed) {
      sessionStorage.removeItem('canAccessReconnect');
    }
  }, [allowed]);

  if (!allowed) {
    return <Navigate to="/" replace />;
  }

  const handleReconnect = () => {
    const ROOM = localStorage.getItem('UNITY');

    try {
      ws.send(ROOM + ":RECONNECT");
      console.log("Message envoyé: RECONNECT");

      // Rediriger vers la page OnTV après reconnexion
      sessionStorage.setItem('canAccessOnTV', 'true');
      navigate("/onTV", { state: { fromAuthorized: true } });
    } catch (error) {
      console.error('Erreur lors de l\'envoi du message RECONNECT :', error);
    }
  };

  const handleDisconnect = () => {
    // Retour à la page d'accueil sans envoyer de message
    navigate('/');
  };

  return (
    <div className="boxform">
      <h1 className="title">{translations.reconnect?.title || 'Reconnexion'}</h1>
      <p className="subtitle" style={{ marginTop: '20px', fontSize: '1.2rem', textAlign: 'center' }}>
        {translations.reconnect?.message || 'Voulez-vous vous reconnecter à la session ?'}
      </p>
      <div className="buttons-container" style={{ display: 'flex', flexDirection: 'column', gap: '15px', marginTop: '30px', width: '100%', maxWidth: 'min(400px, 90vw)' }}>
        <button onClick={handleReconnect} className="submit-button">
          {translations.reconnect?.reconnectButton || 'Se reconnecter'}
        </button>
        <button onClick={handleDisconnect} className="submit-button" style={{ background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)' }}>
          {translations.reconnect?.disconnectButton || 'Se déconnecter'}
        </button>
      </div>
    </div>
  );
}

export default Reconnect;
